import get from 'lodash.get';
import TROClient from '../clients/reading/TROClient';
import {
    TRO_CONFIRMATION_POPUP,
    REVERT_TRO_BOOK,
    PATCH_TRO_REMARKS,
    FETCH_TRO_BOOK_DATA,
    FETCH_ALL_TRO_BOOKS_DATA,
} from '../actionTypes/reading/apiActionTypes';
import { troRescoringWithThirdBookEvent } from '../lrs/reading/lrsActions';
import { isNeedAdditionalBook } from '../../utils/reading/troUtils';
import { apiActionCreator } from '../actionCreators';
import { selectors } from '../../root/reading/root';
import { isMuniOrDistrictGroupUser } from '../../utils/shared/resultReducerHelper';

// TODD think where to pup this action
export const showTroConfirmationPopup = payload => ({
    type: TRO_CONFIRMATION_POPUP.SHOW,
    payload,
});
// TODD think where to pup this action
export const closeTroConfirmationPopup = () => ({
    type: TRO_CONFIRMATION_POPUP.CLOSE,
});

export const fetchTroBookData = bookId => async dispatch => {
    const additionalApiParams = {
        apiParams: [bookId],
    };
    await apiActionCreator(
        dispatch,
        FETCH_TRO_BOOK_DATA,
        TROClient.getBookData,
        additionalApiParams,
    );
};

export const revertTroBookData =
    (resultId, userId, troAudioSrc, bookId) => async (dispatch, getState) => {
        const { districtId, schoolId } = selectors.getCommonData(getState());
        const instUid = isMuniOrDistrictGroupUser(schoolId) ? districtId : schoolId;

        const additionalApiParams = {
            preApiCallCalback: async () => {
                await TROClient.revertTroContentRemarks(resultId, userId, bookId, instUid);
            },
            apiParams: [resultId, instUid],
            additionalResponseParams: { bookId, troAudioSrc },
        };
        await apiActionCreator(
            dispatch,
            REVERT_TRO_BOOK,
            TROClient.getTroResultById,
            additionalApiParams,
        );
    };

export const patchTroBookData =
    (resultId, currentResult, bookId, troAudioSrc, userId, data, complexityLevel) =>
    async (dispatch, getState) => {
        const { districtId, schoolId } = selectors.getCommonData(getState());
        const instUid = isMuniOrDistrictGroupUser(schoolId) ? districtId : schoolId;

        const additionalApiParams = {
            preApiCallCalback: async () => {
                await TROClient.updateTroContentRemarks(resultId, userId, data, instUid);
            },
            afterApiCallCalback: response => {
                dispatch(
                    showTroConfirmationPopup({
                        currentResult,
                        updatedResult: response,
                        complexityLevel,
                    }),
                );
                const updatedBooks = get(response.measure_result, 'book_results', []);
                if (isNeedAdditionalBook(updatedBooks)) dispatch(troRescoringWithThirdBookEvent());
            },
            apiParams: [resultId, instUid],
            additionalResponseParams: { bookId, troAudioSrc },
        };

        await apiActionCreator(
            dispatch,
            PATCH_TRO_REMARKS,
            TROClient.getTroResultById,
            additionalApiParams,
        );
    };

export const fetchAllTroBooksData =
    (successfulCallback = () => {}) =>
    async dispatch => {
        const additionalApiParams = {
            afterApiCallCalback: () => {
                successfulCallback();
            },
        };
        await apiActionCreator(
            dispatch,
            FETCH_ALL_TRO_BOOKS_DATA,
            TROClient.getAllTroBooksData,
            additionalApiParams,
        );
    };
